import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Grid from '../../../common/components/Grid'
import Typography from 'material-ui/Typography'
import TextField from 'material-ui/TextField'
import Avatar from 'material-ui/Avatar'
import AccountCircleIcon from 'material-ui-icons/AccountCircle'
import Dialog, {DialogTitle, DialogContent, DialogActions} from 'material-ui/Dialog'
import Dropzone from 'react-dropzone'
import Button from 'material-ui/Button'

import {profileBasic as text} from '../text'
import styles from '../styles'
import LoadingButton from '../../../common/components/LoadingButton'
import {Link} from '../../../components'
import ChangePhoneDialog from './ChangePhoneDialog'
import ChangePasswordDialog from './ChangePasswordDialog'

class ProfileBasic extends React.Component {

  state = {
    open: false,
    file: null,
  }

  setOpenDialog = open => {
    this.setState({open})
  }

  onDropAccepted = files => {
    if (files.length === 0) return
    const file = files[0]
    if (!file) return

    const reader = new FileReader()

    reader.readAsDataURL(file)

    reader.onloadend = () => {
      this.props.setPicture(reader.result)
    }

    this.props.setFile(file)
    this.setState({file})
  }

  handleSavePicture = () => {
    this.setOpenDialog(false)
    this.setState({file: null})
    this.props.savePicture()
  }

  handleCancelPicture = () => {
    this.setOpenDialog(false)
    this.props.setFile('')
    this.props.setPicture('')
    this.setState({file: null})
  }

  render() {
    const {classes, picture, fbUser} = this.props
    return (
      <div className={classes.tabContainer}>
        <Grid container>
          <Grid item xs={12}>
            {picture.value && picture.value !== ''
              ?
              <Avatar
                alt="Usuario"
                src={picture.value}
                className={classes.avatar}
                imgProps={{style: {height: '100%', objectFit: 'cover'}}}
                onClick={() => this.setOpenDialog(true)}
              />
              :
              <Avatar
                alt="Usuario"
                className={classes.avatar}
                onClick={() => this.setOpenDialog(true)}
              >
                <AccountCircleIcon style={{width: 72, height: 72}}/>
              </Avatar>
            }
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={text.labelName}
                  fullWidth
                  value={this.props.name.value}
                  onChange={e => this.props.setName(e.target.value)}/>
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={text.labelLastName}
                  fullWidth
                  value={this.props.lastName.value}
                  onChange={e => this.props.setLastName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={text.labelEmail}
                  fullWidth
                  value={this.props.email.value}
                  onChange={e => this.props.setEmail(e.target.value)}
                  error={this.props.email.error !== ''}
                  helperText={this.props.email.error}
                />
                {!fbUser &&
                  <Link
                      upperCase={false}
                      onClick={() => this.props.setOpenPasswordDialog(true)}
                  >
                    {text.modifyPassword}
                  </Link>
                }
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  label={text.labelPhoneNumber}
                  fullWidth
                  value={this.props.number.value}
                  onChange={e => this.props.setNumber(e.target.value)}
                  disabled={true}
                />
                <Link
                  upperCase={false}
                  onClick={() => this.props.setOpenPhoneDialog(true)}
                >
                  {text.modifyPhone}
                </Link>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div style={{textAlign: 'right'}}>
              <LoadingButton
                variant="primary"
                onClick={this.props.save}
                isLoading={this.props.isSaving}
              >
                {text.save}
              </LoadingButton>
            </div>
          </Grid>
          {
            this.props.error !== '' &&
            <Grid item xs={12}>
              <Typography className={classes.error}>{this.props.error}</Typography>
            </Grid>
          }
        </Grid>
        <Dialog open={this.state.open} onClose={() => this.setOpenDialog(false)}>
          <DialogTitle>{text.profilePicture}</DialogTitle>
          <DialogContent>
            <Dropzone
              accept="image/*"
              multiple={false}
              onDropAccepted={this.onDropAccepted}
            >
              {this.state.file === null
                ?
                <div className={classes.previewText}>
                  <Typography>{text.pictureBody}</Typography>
                </div>
                :
                <img src={this.state.file.preview} className={classes.avatarPreview} alt="Foto de perfil"/>
              }
            </Dropzone>
          </DialogContent>
          <DialogActions style={{justifyContent: 'space-around'}}>
            <Button onClick={this.handleCancelPicture}>
              {text.cancel}
            </Button>
            <LoadingButton
              color="primary"
              isLoading={this.props.isSaving}
              onClick={this.handleSavePicture}
            >
              {text.accept}
            </LoadingButton>
          </DialogActions>
        </Dialog>
        <ChangePhoneDialog
          dialog={this.props.phoneDialog}
          number={this.props.number}
          save={this.props.saveNumber}
          sendCode={this.props.sendPhoneCode}
          setCode={this.props.setPhoneCode}
          setNumber={this.props.setNumber}
          setOpenDialog={this.props.setOpenPhoneDialog}
        />
        <ChangePasswordDialog
          setOpenDialog={this.props.setOpenPasswordDialog}
          save={this.props.savePassword}
          show={this.props.passwordDialog.show}
          confirmPassword={this.props.confirmPassword}
          currentPassword={this.props.currentPassword}
          error={this.props.passwordDialog.error}
          isSaving={this.props.passwordDialog.isSaving}
          newPassword={this.props.newPassword}
          setConfirmPassword={this.props.setConfirmPassword}
          setCurrentPassword={this.props.setCurrentPassword}
          setNewPassword={this.props.setNewPassword}
        />
      </div>
    )
  }
}

ProfileBasic.propTypes = {
  fbUser: PropTypes.bool,
  setName: PropTypes.func,
  name: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setLastName: PropTypes.func,
  lastName: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setPicture: PropTypes.func,
  setFile: PropTypes.func,
  picture: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  savePicture: PropTypes.func,
  setEmail: PropTypes.func,
  email: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  number: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  phoneDialog: PropTypes.shape({
    show: PropTypes.bool,
    code: PropTypes.shape({
      value: PropTypes.string,
      error: PropTypes.string,
    }),
    isSaving: PropTypes.bool,
    isSending: PropTypes.bool,
    error: PropTypes.string,
  }),
  setNumber: PropTypes.func,
  setPhoneCode: PropTypes.func,
  sendPhoneCode: PropTypes.func,
  setOpenPhoneDialog: PropTypes.func,
  saveNumber: PropTypes.func,
  setCurrentPassword: PropTypes.func,
  currentPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setNewPassword: PropTypes.func,
  newPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setConfirmPassword: PropTypes.func,
  confirmPassword: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.string,
  }),
  setOpenPasswordDialog: PropTypes.func,
  passwordDialog: PropTypes.shape({
    show: PropTypes.bool,
    error: PropTypes.string,
    isSaving: PropTypes.bool,
  }),
  savePassword: PropTypes.func,
  save: PropTypes.func,
  isSaving: PropTypes.bool,
  error: PropTypes.string,
}

export default withStyles(styles, {withTheme: true})(ProfileBasic)



// WEBPACK FOOTER //
// ./src/sections/profile/components/ProfileBasic.js